import * as React from 'react';
import S from './Breadcrumb.styles';
const Breadcrumb = (props) => {
    if (!props.items || props.items.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, { variant: props.variant, flush: "both" },
        React.createElement(S.List, { "aria-label": "breadcrumb" }, props.items.map((item, i) => (React.createElement(React.Fragment, { key: `breadcrumb-${i}` }, i >= props.items.length - 2 ? (React.createElement(React.Fragment, null,
            i > 0 && i !== props.items.length - 1 ? (React.createElement(S.Item, { "data-ellip": "true" }, "\u2026")) : null,
            React.createElement(S.Item, null,
                React.createElement(S.ItemLink, { href: item.url, title: item.text, "aria-current": i === props.items.length - 1 ? 'location' : undefined }, item.text)))) : null))))));
};
export default Breadcrumb;
